import React from 'react';
import { ShieldCheckIcon, SparklesIcon, CreditCardIcon, RepeatIcon, HeadphonesIcon } from 'lucide-react';
import { Reveal } from '../ui/Reveal';
const items = [{
  icon: ShieldCheckIcon,
  title: 'Usados seleccionados',
  text: 'Revisados unidad por unidad'
}, {
  icon: SparklesIcon,
  title: 'Vehículos 0KM',
  text: 'Con entrega coordinada'
}, {
  icon: CreditCardIcon,
  title: 'Financiación hasta el 100%',
  text: 'Planes a tu medida'
}, {
  icon: RepeatIcon,
  title: 'Aceptamos permutas',
  text: 'Tu usado como parte de pago'
}, {
  icon: HeadphonesIcon,
  title: 'Atención personalizada',
  text: 'Un asesor de principio a fin'
}];
export function Confianza() {
  return <section aria-label="Beneficios de comprar en VCARS" className="border-t border-line/60 bg-surface py-10 md:py-14" data-id="element-254" data-mp="2b47pxlq691k5">
      <div className="mx-auto w-full max-w-7xl px-5 md:px-8" data-id="element-255" data-mp="1x5hsg4zfwzv9">
        <ul className="grid gap-3 sm:grid-cols-2 lg:grid-cols-5" data-id="element-256" data-mp="223jhr7nglvf6">
          {items.map(({
          icon: Icon,
          title,
          text
        }, i) => <Reveal key={title} delay={i * 0.04} className="h-full" data-id="element-257" data-mp="34m9ms6o6mo8c" data-mpi={i}>
              <li className="group h-full rounded-2xl border border-line bg-surface2/40 p-5 backdrop-blur-sm transition-[border-color,transform,box-shadow] duration-200 ease-smooth hover:-translate-y-0.5 hover:border-neon/60 hover:shadow-[0_0_28px_-12px_rgba(31,123,255,0.9)]" data-id="element-258" data-mp="2znydbx1sufqn">
                <span className="inline-grid h-10 w-10 place-items-center rounded-xl bg-neon/12 text-neon transition-colors duration-150 ease-smooth group-hover:bg-neon/20" data-id="element-259" data-mp="38mjy7yuqu6ul">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-260" data-mp="2gz1my49iw7dp" />
                </span>
                <h3 className="mt-4 text-[15px] font-bold leading-snug text-white" data-id="element-261" data-mp="2upn7dxemkpdp">
                  {title}
                </h3>
                <p className="mt-1 text-[13px] leading-relaxed text-mist" data-id="element-262" data-mp="2pw26nxlndhat">{text}</p>
              </li>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}